import React, { SVGProps } from "react";

interface LocationIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const LocationIcon: React.FC<LocationIconProps> = ({ className, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.33334C5.05448 1.33334 2.66667 3.72115 2.66667 6.66667C2.66667 10.3333 8 14.6667 8 14.6667C8 14.6667 13.3333 10.3333 13.3333 6.66667C13.3333 3.72115 10.9455 1.33334 8 1.33334ZM8 8.66667C6.89543 8.66667 6 7.77124 6 6.66667C6 5.5621 6.89543 4.66667 8 4.66667C9.10457 4.66667 10 5.5621 10 6.66667C10 7.77124 9.10457 8.66667 8 8.66667Z"
      fill="currentColor"
    />
  </svg>
);

export default LocationIcon;
